const teamList=[
    {
        picture:require('@/assets/person/胡勇.jpg'),
        title:'胡勇',
        tag:'正高级工程师',
        power:'咨询工程师（投资）、一级造价工程师、一级建造师、监理工程师、IPMP（B级）、工料测量师',
        area:'企业管理、战略管理、全过程咨询',
    },
    {
        picture:require('@/assets/person/尉宏广.jpg'),
        title:'尉宏广',
        tag:'高级工程师',
        power:'IPMP（B级）',
        area:'企业管理、战略管理、人力资源管理'
    },
    {
        picture:require('@/assets/person/郭建淼.jpg'),
        title:'郭建淼',
        tag:'正高级工程师',
        power:'咨询工程师（投资）、一级造价工程师、一级建造师、监理工程师、IPMP（B级）、工料测量师、图学会二级BIM建模师、工信部BIM应用设计师、人社部BIM应用设计师',
        area:'全过程咨询、造价咨询、合约咨询、BIM咨询'
    },
    {
        picture:require('@/assets/person/李淼.jpg'),
        title:'李淼',
        tag:'正高级经济师',
        power:'咨询工程师（投资）、IPMP（B级）',
        area:'项目前期咨询、宏观经济与政策、规划咨询、财务评价、PPP咨询'
    },
    {
        picture:require('@/assets/person/车明海.jpg'),
        title:'车明海',
        tag:'正高级工程师',
        power:'咨询工程师（投资）、监理工程师、一级建造师、IPMP（B级）',
        area:'企业管理、市场营销、全过程咨询、招标采购咨询'
    },
    {
        picture:require('@/assets/person/聂庆宇.jpg'),
        title:'聂庆宇',
        tag:'正高级工程师',
        power:'咨询工程师（投资）、监理工程师、一级建造师、二级建造师、IPMP（C级）',
        area:'招标投标咨询、数智化、PMO'
    },
    {
        picture:require('@/assets/person/耿艳娜.jpg'),
        title:'耿艳娜',
        tag:'正高级工程师',
        power:'咨询工程师（投资）、监理工程师、一级造价工程师',
        area:'造价咨询、合约咨询'
    },
    {
        picture:require('@/assets/person/李凌.jpg'),
        title:'李凌',
        tag:'正高级经济师',
        power:'咨询工程师（投资）、监理工程师、一级造价工程师、一级建造师、IPMP（C级）',
        area:'造价咨询、合约咨询'
    },
    {
        picture:require('@/assets/person/刘志伟.jpg'),
        title:'刘志伟',
        tag:'正高级工程师',
        power:'咨询工程师（投资）、监理工程师、一级造价工程师、一级建造师、IPMP（C级）、欧特克认证的Revit讲师和工程师',
        area:'全过程咨询、项目管理、BIM咨询'
    },
    {
        picture:require('@/assets/person/巴音王子.jpg'),
        title:'巴音王子',
        tag:'高级律师',
        power:'法律职业资格',
        area:'法律顾问、业务合同条款咨询、PPP项目合同的编写、谈判'
    },
    {
        picture:require('@/assets/person/焦云立.jpg'),
        title:'焦云立',
        tag:'正高级工程师',
        power:'咨询工程师（投资）、一级造价工程师',
        area:'造价咨询、合约咨询'
    },
    {
        picture:require('@/assets/person/庞红杰.jpg'),
        title:'庞红杰',
        tag:'正高级工程师',
        power:'二级建造师、IPMP（B级）',
        area:'造价咨询、全过程工程咨询'
    },
    {
        picture:require('@/assets/person/张凤荣.jpg'),
        title:'张凤荣',
        tag:'正高级工程师',
        power:'咨询工程师（投资）、一级造价工程师、IPMP（C级）',
        area:'造价咨询、安装、估算、概算、BIM咨询'
    },
    {
        picture:require('@/assets/person/胡颖.jpg'),
        title:'胡颖',
        tag:'正高级工程师',
        power:'一级造价工程师、监理工程师、二级建造师',
        area:'造价咨询、合约咨询'
    },
    {
        picture:require('@/assets/person/李丽菊.jpg'),
        title:'李丽菊',
        tag:'正高级工程师',
        power:'IPMP（C级）',
        area:'管理体系建设、人力资源管理、项目管理、合规风控与资信品牌建设'
    },
    {
        picture:require('@/assets/person/王娜.jpg'),
        title:'王娜',
        tag:'正高级工程师',
        power:'监理工程师、二级建造师',
        area:'资质资信、招标投标咨询'
    },
    {
        picture:require('@/assets/person/赵瑞鑫.jpg'),
        title:'赵瑞鑫',
        tag:'正高级工程师',
        power:'IPMP（B级）',
        area:'招标投标、市场营销'
    },
    {
        picture:require('@/assets/person/陈志鹏.jpg'),
        title:'陈志鹏',
        tag:'正高级工程师',
        power:'IPMP（B级）',
        area:'招标投标咨询'
    },
    {
        picture:require('@/assets/person/蒋红红.jpg'),
        title:'蒋红红',
        tag:'正高级工程师',
        power:'一级造价工程师',
        area:'造价咨询、合约咨询'
    },
    {
        picture:require('@/assets/person/李志军.jpg'),
        title:'李志军',
        tag:'正高级工程师',
        power:'IPMP（B级）',
        area:'招标投标咨询'
    },
    {
        picture:require('@/assets/person/张雪辉.jpg'),
        title:'张雪辉',
        tag:'正高级工程师',
        power:'咨询工程师（投资）、IPMP（C级）',
        area:'招标投标咨询'
    },
    {
        picture:require('@/assets/person/沈尚宏.jpg'),
        title:'沈尚宏',
        tag:'正高级工程师',
        power:'IPMP（B级）',
        area:'招标投标咨询、轨道交通'
    },
    {
        picture:require('@/assets/person/王浩.jpg'),
        title:'王浩',
        tag:'高级工程师',
        power:'/',
        area:'招标投标咨询、轨道交通'
    },
    {
        picture:require('@/assets/person/郭永林.jpg'),
        title:'郭永林',
        tag:'高级会计师',
        power:'咨询工程师（投资）、IPMP（C级）',
        area:'绩效管理、财务管理'
    },
    {
        picture:require('@/assets/person/李永涛.jpg'),
        title:'李永涛',
        tag:'高级工程师',
        power:'咨询工程师（投资）、监理工程师、一级造价工程师、一级建造师、二级建造师、IPMP（C级）',
        area:'招标投标咨询、特许经营项目咨询'
    },
    {
        picture:require('@/assets/person/鲁健.jpg'),
        title:'鲁健',
        tag:'高级工程师',
        power:'咨询工程师（投资）、一级建造师、IPMP（C级）',
        area:'交通项目招标咨询'
    },
    {
        picture:require('@/assets/person/杨建华.png'),
        title:'杨建华',
        tag:'高级工程师',
        power:'咨询工程师（投资）',
        area:'项目前期咨询、宏观经济与政策、稳评'
    },
    {
        picture:require('@/assets/person/樊永刚.jpg'),
        title:'樊永刚',
        tag:'高级工程师',
        power:'咨询工程师（投资）',
        area:'项目前期咨询、财务评价、稳评'
    },
    {
        picture:require('@/assets/person/殷文聪.jpg'),
        title:'殷文聪',
        tag:'高级工程师',
        power:'咨询工程师（投资）、IPMP（C级）',
        area:'项目前期咨询、宏观经济与政策、规划咨询、财务评价、特许经营咨询'
    },
    {
        picture:require('@/assets/person/甄利凯.jpg'),
        title:'甄利凯',
        tag:'高级工程师',
        power:'咨询工程师（投资）、一级造价工程师、IPMP（C级）',
        area:'项目前期咨询、宏观经济与政策、规划咨询、财务评价、PPP咨询'
    },
    {
        picture:require('@/assets/person/张慧敬.jpg'),
        title:'张慧敬',
        tag:'高级工程师',
        power:'咨询工程师（投资）、监理工程师、二级建造师',
        area:'投资决策综合性咨询、政府和社会资本合作咨询、工程咨询数字化应用'
    },
    {
        picture:require('@/assets/person/李小玲.jpg'),
        title:'李小玲',
        tag:'高级经济师',
        power:'咨询工程师（投资）、监理工程师、注册城乡规划师',
        area:'发展规划、产业规划编制、cad、ps'
    },
    {
        picture:require('@/assets/person/贾向敬.jpg'),
        title:'贾向敬',
        tag:'高级工程师',
        power:'咨询工程师（投资）、监理工程师、一级造价工程师、一级建造师',
        area:'造价咨询，土建、市政、信息化'
    },
    {
        picture:require('@/assets/person/赵戌峰.jpg'),
        title:'赵戌峰',
        tag:'高级工程师',
        power:'咨询工程师（投资）、监理工程师、一级造价工程师、IPMP（C级）',
        area:'造价咨询、合约咨询'
    },
    {
        picture:require('@/assets/person/宋志红.jpg'),
        title:'宋志红',
        tag:'高级工程师',
        power:'咨询工程师（投资）、监理工程师、一级造价工程师、一级建造师、IPMP（C级）、图学会一二级BIM建模师、欧特克认证的Revit讲师和工程师',
        area:'全过程咨询、项目管理、BIM咨询、合约咨询'
    },
    {
        picture:require('@/assets/person/李东坡.png'),
        title:'李东坡',
        tag:'高级工程师',
        power:'咨询工程师（投资）、监理工程师、一级造价工程师、一级建造师',
        area:'全过程咨询、项目管理'
    },
    {
        picture:require('@/assets/person/彭祥俊.jpg'),
        title:'彭祥俊',
        tag:'高级工程师',
        power:'监理工程师',
        area:'全过程咨询、项目管理'
    },
    {
        picture:require('@/assets/person/郑俊.jpg'),
        title:'郑俊',
        tag:'高级工程师',
        power:'咨询工程师（投资）',
        area:'节能、稳评、工业类可研、外贷、项目申报'
    },
    {
        picture:require('@/assets/person/张红楼.jpg'),
        title:'张红楼',
        tag:'高级工程师',
        power:'监理工程师、一级建造师、IPMP（C级）',
        area:'全过程咨询、项目管理'
    },
    {
        picture:require('@/assets/person/史君汝.jpg'),
        title:'史君汝',
        tag:'高级工程师',
        power:'图学会一二级BIM建模师、工信部BIM应用设计师、人社部BIM应用设计师、欧特克认证的Revit工程师',
        area:'BIM咨询、设计管理'
    },
]

export default teamList